'use strict';

const Reflux = require('@muzzylane/reflux');

const ServerRequest = require('../actions/request');

const SiteConfigActions = Reflux.createActions({
    getSiteConfig: { children: ['completed', 'failed'] },
    updateSiteConfig: { children: ['completed', 'failed'] },
    getSiteMessage: { children: ['completed', 'failed'] },
    getMaintenanceMode: { children: ['completed', 'failed'] },
    getSiteFeatures: { children: ['completed', 'failed'] },
});

SiteConfigActions.getSiteConfig.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/site_config', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

SiteConfigActions.updateSiteConfig.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/site_config', 'PUT', JSON.stringify({
            example_project_id: params.exampleProjectId || 0,
            example_project_name: params.exampleProjectName,
            registration_org_id: params.registrationOrgId,
            registration_org_role_token: params.registrationOrgRoleToken,
            site_message: params.siteMessage,
            maintenance_mode: params.maintenanceMode,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

SiteConfigActions.getSiteMessage.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/site_message', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

SiteConfigActions.getMaintenanceMode.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/maintenance_mode', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

SiteConfigActions.getSiteFeatures.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/site_features', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

module.exports = SiteConfigActions;